import ChangePassword from './ChangePassword'
import enhance from './ChangePassword.enhancer'

export default enhance(ChangePassword)



// WEBPACK FOOTER //
// ./src/containers/account/ChangePassword/index.js